import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Numeral from 'numeral';
import containerActions from '../../actions';

import closeImg from './img/close.png';
import EditCarInformation from './components/EditCarInformation';
import './styles.scss';

class EditAddCarData extends Component {
  constructor () {
    super();
    this.state = {
      finishButtonState: true
    };
  }

  componentDidMount() {
    this.checkNecessaryInputData();
  }
  setSeating = (e) => {
    const buff = this.props.carData;
    buff.listings.build.std_seating = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  setDoors = (e) => {
    const buff = this.props.carData;
    buff.listings.build.doors = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  setInteriorColor = (e) => {
    const buff = this.props.carData;
    buff.listings.interior_color = e.target.value;
    buff.listings.base_int_color = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  setExteriorColor = (e) => {
    const buff = this.props.carData;
    buff.listings.exterior_color = e.target.value;
    buff.listings.base_ext_color = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  setCarType = (e) => {
    const buff = this.props.carData;
    buff.listings.build.body_type = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  enterManufacturer = (e) => {
    const buff = this.props.carData;
    buff.listings.build.make = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
    this.genHeading();
  }
  enterModel = (e) => {
    const buff = this.props.carData;
    buff.listings.build.model = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
    this.genHeading();
  }
  enterProductionYear = (e) => {
    const buff = this.props.carData;
    if (e.target.value.length > 0 && parseInt(e.target.value, 10)) {
      buff.listings.build.year = parseInt(e.target.value, 10);
    }
    if (e.target.value.length === 0) {
      buff.listings.build.year = '';
    }
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
    this.genHeading();
  }
  enterMileage = (e) => {
    const buff = this.props.carData;
    // eslint-disable-next-line
    const numTemp = Numeral(e.target.value)['_value'];
    // eslint-disable-next-line
    if (Numeral(e.target.value)['_input'].length > 0 && numTemp) {
      buff.listings.miles = numTemp;
    }
    // eslint-disable-next-line
    if (Numeral(e.target.value)['_input'].length === 0) {
      buff.listings.miles = '';
    }
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  enterVehicleCost = (e) => {
    const buff = this.props.carData;
    if (e.target.value[e.target.value.length - 1] === '.' && e.target.value.length - 1 !== 0) {
      buff.listings.price = e.target.value;
    } else {
      // eslint-disable-next-line
      const numTemp = Numeral(e.target.value)['_value'];
      // eslint-disable-next-line
      if (Numeral(e.target.value)['_input'].length > 0 && numTemp) {
        buff.listings.price = numTemp.toString();
      }
    }
    if (e.target.value.length === 2) {
      buff.listings.price = '';
    }
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  enterTransmission = (e) => {
    const buff = this.props.carData;
    buff.listings.build.transmission = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  enterFuelType = (e) => {
    const buff = this.props.carData;
    buff.listings.build.fuel_type = e.target.value;
    this.checkNecessaryInputData();
    this.props.loadCarData(buff);
  }
  genHeading = () => {
    const buff = this.props.carData;
    buff.listings.heading = `${buff.listings.build.year} ${buff.listings.build.make} ${buff.listings.build.model}`;
    this.props.loadCarData(buff);
  }
  closeEditCarPage = () => {
    this.props.SetActionPage('');
  }
  AddCarFinish = () => {
    this.props.SetActionPage('');
  }
  uploadImgHandl = (e) => {
    if (e.target.files) {
      // const fd = new FormData();
      // Object.keys(e.target.files).forEach((element, index) => {
      //   fd.append('file', e.target.files[index]);
      // });
      this.props.EditUploadImgCar(e.target.files);
    }
    this.checkNecessaryInputData();
  }
  goToFinish = () => {
    this.props.EditCarReq({ car: this.props.carData });
    this.props.SetActionPage('carData');
  }

  editDelImgHandl = (url) => {
    this.props.EditDelImgUrlToCarData(url);
    this.checkNecessaryInputData();
  }
  checkNecessaryInputData = () => {
    if (
      (this.props.carData.listings.build.body_type &&
        this.props.carData.listings.build.body_type.length === 0) ||
      (this.props.carData.listings.build.make &&
        this.props.carData.listings.build.make.length === 0) ||
      (this.props.carData.listings.build.model &&
        this.props.carData.listings.build.model.length) === 0 ||
      (this.props.carData.listings.build.year &&
        this.props.carData.listings.build.year.length === 0) ||
      (this.props.carData.listings.miles &&
        this.props.carData.listings.miles.length === 0) ||
      (this.props.carData.listings.price &&
        this.props.carData.listings.price.length === 0) ||
      (this.props.carData.listings.build.transmission &&
        this.props.carData.listings.build.transmission.length === 0) ||
      (this.props.carData.listings.build.fuel_type &&
        this.props.carData.listings.build.fuel_type.length === 0) ||
      (this.props.carData.listings.exterior_color &&
        this.props.carData.listings.exterior_color.length === 0) ||
      (this.props.carData.listings.interior_color &&
        this.props.carData.listings.interior_color.length === 0) ||
      (this.props.carData.listings.build.doors &&
        this.props.carData.listings.build.doors.length === 0) ||
      (this.props.carData.listings.build.std_seating &&
        this.props.carData.listings.build.std_seating.length === 0)
    ) {
      this.setState({
        finishButtonState: true
      });
    } else {
      this.setState({
        finishButtonState: false
      });
    }
  }
  render() {
    return (
      <div className="body-EditCar">
        <div
          className="heder-EditCar"
          style={this.props.scrollLeft > 1 ? { left: `-${this.props.scrollLeft}px` } : { }}
        >
          <div className="closeButtonField-EditCar">
            <button onClick={this.closeEditCarPage}>
              <img className="closeButton-EditCar" src={closeImg} alt="" />
            </button>
          </div>
          <div className="title-EditCar">Edit a car</div>
        </div>
        <div className="page-EditCar">
          <EditCarInformation
            setCarType={this.setCarType}
            enterManufacturer={this.enterManufacturer}
            enterModel={this.enterModel}
            enterProductionYear={this.enterProductionYear}
            enterMileage={this.enterMileage}
            enterVehicleCost={this.enterVehicleCost}
            enterTransmission={this.enterTransmission}
            enterFuelType={this.enterFuelType}
            finishButtonState={this.state.finishButtonState}
            goToFinish={this.goToFinish}
            closeEditCarPage={this.closeEditCarPage}
            setExteriorColor={this.setExteriorColor}
            setInteriorColor={this.setInteriorColor}
            setDoors={this.setDoors}
            setSeating={this.setSeating}
            data={this.props.carData}
            editDelImgHandl={this.editDelImgHandl}
            uploadImgHandl={this.uploadImgHandl}
          />
        </div>
      </div>
    );
  }
}

EditAddCarData.propTypes = {
  EditUploadImgCar: PropTypes.func.isRequired,
  carData: PropTypes.instanceOf(Object).isRequired,
  SetActionPage: PropTypes.func.isRequired,
  loadCarData: PropTypes.func.isRequired,
  EditDelImgUrlToCarData: PropTypes.func.isRequired,
  EditCarReq: PropTypes.func.isRequired,
  scrollLeft: PropTypes.number.isRequired
};
const mapStateToProps = state => ({
  carData: state.careditor.pagesData.carData
});

export default connect(mapStateToProps, containerActions)(EditAddCarData);



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/changeCarData/index.js